import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from '../ApiKeySettings.module.scss';
import TextField from 'components/TextField';
import {useForm} from 'react-hook-form';
import FormActionGroup from 'components/FormActionGroup';
import Button from 'components/Button';

type CreateKeyFormData = {
  name: string;
};

type CreateKeyModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateKeyFormData) => void;
  loading: boolean;
};

function CreateKeyModal({
  isOpen,
  onClose,
  onSubmit,
  loading,
}: CreateKeyModalProps) {
  const {
    register,
    formState: {errors},
    handleSubmit,
  } = useForm<CreateKeyFormData>({
    defaultValues: {
      name: '',
    },
  });
  const handleSubmitCreateKey = (data: CreateKeyFormData) => {
    onSubmit(data);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.createKeyModal}
    >
      <Typography variant="h2">Create API Key</Typography>
      <TextField
        label="Name"
        placeholder="Enter API Key name"
        {...register('name', {required: 'Name is required'})}
        error={errors.name?.message}
      />
      <FormActionGroup className={styles.buttonWrap}>
        <Button
          type="submit"
          onClick={handleSubmit(handleSubmitCreateKey)}
          loading={loading}
        >
          Create
        </Button>
      </FormActionGroup>
    </Modal>
  );
}

export default CreateKeyModal;
